import React, { useState } from 'react';
import { formatDeliveryDate } from 'utils/deliveryDates';
import DeliverySlotSelect, { slotValue, parseSlotValue, formatFee } from './DeliverySlotSelect';

const labelStyle = { display: 'block', marginBottom: '8px', color: '#333', fontWeight: 'bold' };

const formatDelta = (delta) => {
    const cents = Math.round(delta * 100);
    if (!cents) return '';
    return ` (${cents > 0 ? '+' : '-'}${formatFee(cents / 100)})`;
};

// targets: [{ date, times }] — includes fromDate so the time can change without moving
const MoveDeliveryModal = ({ fromDate, itemCount, targets, getDefaultTime, getFeeDelta, hasOrdersOn, onConfirm, onCancel }) => {
    const fromTarget = targets.find(t => t.date === fromDate);
    const [currentSlot] = useState(() => (fromTarget ? slotValue(fromDate, getDefaultTime(fromDate, fromTarget.times)) : ''));
    const [selected, setSelected] = useState(currentSlot);

    const { date: toDate, time: deliveryTime } = parseSlotValue(selected);
    const isSameDate = toDate === fromDate;
    const canConfirm = selected && selected !== currentSlot;

    const slots = targets.flatMap(t => t.times.map(time => ({
        date: t.date,
        time,
        suffix: slotValue(t.date, time) === currentSlot ? ' (current)' : formatDelta(getFeeDelta(t.date, time))
    })));

    return (
        <div style={{
            position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
            <div style={{
                backgroundColor: '#fff', borderRadius: '8px', padding: '24px',
                maxWidth: '480px', width: '90%', maxHeight: '80vh', overflowY: 'auto'
            }}>
                <h3 style={{ marginTop: 0, color: '#333' }}>
                    Edit {formatDeliveryDate(fromDate)} Delivery
                </h3>
                <p style={{ color: '#666', marginBottom: '20px' }}>
                    All {itemCount} item{itemCount === 1 ? '' : 's'} on this date will be delivered on the date and time you pick.
                </p>

                {slots.length === 0 ? (
                    <p style={{ color: '#721c24', backgroundColor: '#f8d7da', padding: '8px', borderRadius: '4px', fontSize: '14px' }}>
                        No delivery dates are available for your zip code right now.
                    </p>
                ) : (
                    <div style={{ marginBottom: '20px' }}>
                        <label htmlFor="move-delivery-slot" style={labelStyle}>Delivery date & time</label>
                        <DeliverySlotSelect
                            id="move-delivery-slot"
                            slots={slots}
                            value={selected}
                            onChange={setSelected}
                            placeholder={currentSlot ? undefined : 'Select a delivery'}
                        />
                        {toDate && !isSameDate && hasOrdersOn(toDate) && (
                            <div style={{ fontSize: '12px', color: '#888', marginTop: '6px' }}>
                                Meals already on {formatDeliveryDate(toDate)} will also be delivered at this time.
                            </div>
                        )}
                    </div>
                )}

                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={onCancel}
                        style={{
                            padding: '10px 20px', border: '1px solid #6c757d', borderRadius: '4px',
                            backgroundColor: '#fff', color: '#6c757d', cursor: 'pointer', fontSize: '14px'
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm(toDate, deliveryTime)}
                        disabled={!canConfirm}
                        style={{
                            padding: '10px 20px', border: 'none', borderRadius: '4px',
                            backgroundColor: canConfirm ? '#ffb13c' : '#ccc',
                            color: '#fff', fontSize: '14px',
                            cursor: canConfirm ? 'pointer' : 'not-allowed'
                        }}
                    >
                        {isSameDate ? 'Change Time' : 'Move Items'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MoveDeliveryModal;
